import { render } from "./aboutModal.vue?vue&type=template&id=3eb0154a&scoped=true"
import script from "./aboutModal.vue?vue&type=script&lang=js"
export * from "./aboutModal.vue?vue&type=script&lang=js"

import "./aboutModal.vue?vue&type=style&index=0&id=3eb0154a&scoped=true&lang=css"
import "./aboutModal.vue?vue&type=style&index=1&id=3eb0154a&lang=css"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb0154a"]])

export default __exports__